class SimpleBannerMarquee {
  constructor(element, options = {}) {
    this.container = element;
    this.options = {
      speed: 50, // 픽셀/초
      direction: "left",
      ...options
    };

    // resize 관련 프로퍼티 추가
    this.resizeTimeout = null;
    this.isResizing = false;
    this.lastTime = 0; // 이전 프레임 시간 저장
    this.stack = []; // 요소 순서 관리를 위한 배열 추가

    this.init();
  }

  init() {
    // 컨테이너 내부의 콘텐츠 요소 가져오기
    this.content = this.container.querySelector(
      ".simple-banner-marquee__content",
    );
    if (!this.content) return;

    this.container.dataset.gap = this.container.dataset.gap || 40; // gap 설정
    this.gapSizePx = (this.container.dataset.gap || 40) + "px";

    // 원본 content 초기화
    this.content.style.display = "block";
    this.content.style.position = "absolute";
    this.content.style.left = "0";
    this.content.style.willChange = "transform";

    this.newContentWidth = 0;
    Array.from(this.content.children).forEach((child) => {
      child.style.marginRight = this.gapSizePx;
      this.newContentWidth += child.offsetWidth + parseInt(this.gapSizePx);
    });
    this.newContentWidth += parseInt(this.gapSizePx);

    // 더 많은 복제본 생성 (화면 너비의 2배 이상 확보)
    const totalWidth = this.container.offsetWidth * 3;
    const cloneCount = Math.ceil(totalWidth / (this.newContentWidth + 20));

    // 필요한 만큼 콘텐츠 복제
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < cloneCount; i++) {
      const clone = this.content.cloneNode(true);
      fragment.appendChild(clone);
    }
    this.container.appendChild(fragment);

    // 요소들을 stack에 추가하고 초기 위치 설정
    Array.from(this.container.children).forEach((element, index) => {
      element.style.left = `${this.newContentWidth * (index + 1)}px`;

      this.stack.push({
        element,
        currentLeft: this.newContentWidth * index,
      });
    });

    this.isHovered = false;
    // 이벤트 리스너 추가
    this.container.addEventListener(
      "mouseenter",
      () => (this.isHovered = true),
    );
    this.container.addEventListener(
      "mouseleave",
      () => (this.isHovered = false),
    );

    // resize 이벤트 리스너 추가
    window.addEventListener("resize", () => this.handleResize());

    // 블러 스타일 초기 설정
    this.container.style.transition = "filter 0.3s ease";
    // 애니메이션 시작
    this.animate();
  }

  resetContent() {
    // 모든 복제된 요소 제거
    while (this.container.children.length > 1) {
      this.container.removeChild(this.container.lastChild);
    }

    // stack 초기화
    this.stack = [];

    // 원본 content 초기화
    this.content.style.left = "0";

    // init 다시 실행
    this.init();
  }

  handleResize() {
    if (!this.isResizing) {
      this.isResizing = true;
      this.container.style.filter = "blur(4px)";
    }

    // 디바운스 처리
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.isResizing = false;
      this.container.style.filter = "none";

      // resize 후 컨텐츠 완전히 재구성
      this.resetContent();
    }, 150);
  }

  animate(currentTime = 0) {
    // deltaTime 계산 (밀리초)
    const deltaTime = currentTime - this.lastTime;
    this.lastTime = currentTime;

    if (!this.isHovered && !this.isResizing) {
      // 프레임 독립적인 움직임을 위한 속도 계산
      const pixelsPerFrame = (this.options.speed / 1000) * deltaTime;
      const direction = this.options.direction === "left" ? -1 : 1;

      // stack의 각 요소 이동
      this.stack.forEach((item) => {
        item.currentLeft += direction * pixelsPerFrame;
        const element = item.element;

        if (this.options.direction === "left") {
          if (item.currentLeft + this.newContentWidth < -300) {
            const lastItem = this.stack[this.stack.length - 1];
            item.currentLeft = lastItem.currentLeft + this.newContentWidth;
            this.stack.push(this.stack.shift());
          }
        }

        // transform으로 위치 업데이트
        // element.style.transform = `translateX(${item.currentLeft}px)`;
        element.style.left = `${item.currentLeft}px`;
      });
    }

    this.animationFrame = requestAnimationFrame((time) => this.animate(time));
  }

  // 컴포넌트 정리를 위한 메서드 추가
  destroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    window.removeEventListener("resize", this.handleResize);
  }
}

// 페이지 로드 시 마퀴 초기화
document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(
    ".simple-banner-marquee__container",
  );
  containers.forEach((container) => {
    const direction = container.dataset.direction || "left";
    const speed =
      parseFloat(container.style.getPropertyValue("--scroll-speed")) || 20;

    new SimpleBannerMarquee(container, {
      direction,
      speed,
    });
  });
});
